import { auth, db } from "../firebase";
import { ref, push } from "firebase/database";
import store from "../Store";
import {
  roleAtom,
  uidAtom,
  isMasterAdminAtom,
  isImpersonationReadOnlyAtom,
} from "../Store/atoms";

const REST_SERVER_URL =
  process.env[
    `REACT_APP_REST_SERVER_URL_${process.env.NODE_ENV.toUpperCase()}`
  ];
const sendDataRest = async (
  unit: number,
  params: [string, string, object, number | undefined],
): Promise<number> => {
  const isMaster = store.get(isMasterAdminAtom);
  const isReadOnly = store.get(isImpersonationReadOnlyAtom);

  // If Master Admin is in Safe Mode (Read-Only), protect client data and block mutations
  if (isMaster && isReadOnly) {
    console.warn("[Safe Mode] Modification blocked: Impersonation Safe Mode is ON.");
    return 403;
  }

  const uid = store.get(uidAtom);
  const role = store.get(roleAtom);
  const { uid: myUID } = auth.currentUser || {};
  const hasAccess = uid === myUID || role === "editor" || isMaster;
  if (!hasAccess) return 401;
  if (!uid) return 0;
  const headers = {
    "Content-Type": "application/json",
    uid,
    unit: String(unit),
  };
  const payload = {
    target: params[0],
    id: params[1],
    data: params[2],
    factory: isNaN(params[3] as number) ? -1 : params[3],
  };
  const URL = REST_SERVER_URL + "/update-data";

  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const response = await fetch(URL, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
      });

      if (response.ok) return response.status;

      if (attempt === 2) {
        const errorLog = {
          timestamp: Date.now(),
          type: "HTTP_ERROR",
          status: response.status,
          url: URL,
          user: { uid, role, myUID },
          request: { unit, payload, headers },
        };

        try {
          const text = await response.text();
          Object.assign(errorLog, { responseBody: text });
        } catch (e) {
          // ignore body read error
        }

        push(ref(db, "/admin/error-logs/"), errorLog);
        return response.status;
      }
    } catch (error: any) {
      if (attempt === 2) {
        const errorLog = {
          timestamp: Date.now(),
          type: "NETWORK_ERROR",
          url: URL,
          user: { uid, role, myUID },
          request: { unit, payload, headers },
          error: error.message || String(error),
        };
        push(ref(db, "/admin/error-logs/"), errorLog);
        return 0;
      }
    }
  }
  return 0;
};

export default sendDataRest;
export { REST_SERVER_URL };
